import * as React from 'react';
import PropTypes from 'prop-types';

import TAppPage from '../../APP/TAppPage';

import ErrorBoundaryPage from '../../common/ErrorBoundaryPage';

import * as rcc from "../NonVisual/RCConst";

import RCWelcomeForm from "../Forms/RCWelcomeForm";
import RCSelectIndicatorsForm from "../Forms/RCSelectIndicatorsForm";
import RCAssignTargPopsForm from "../Forms/RCAssignTargPopsForm";
import RCParametersForm from "../Forms/RCParametersForm";
import RCResultsForm from "../Forms/RCResultsForm";
import RCCustomIndicatorDrawer from "../Drawers/RCCustomIndicatorDrawer";


class RCAppContent extends React.Component {

    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {

        appBarHeight                : PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        appSideBarWidth             : PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

        appState                    : PropTypes.object,
        onStateChange               : PropTypes.func,

        onAddTasks                  : PropTypes.func,
        getDataVisChart             : PropTypes.func,
        onDrawerChange              : PropTypes.func,
        onPageChange                : PropTypes.func,
        onProjChange                : PropTypes.func,
        onPackTableChange           : PropTypes.func,

        left                        : PropTypes.number,

        onQ1Answered                : PropTypes.func,
        onQ2Answered                : PropTypes.func,

        onSideBarArrowClick         : PropTypes.func,

        onTargPopParamValueChange   : PropTypes.func,
        onTargPopCustomStrChange    : PropTypes.func,
        onSelectedIndicatorChange   : PropTypes.func,
        onAnalyzeIndicatorChange    : PropTypes.func,
        onIndicatorNameChange       : PropTypes.func,
        onGroupNameChange           : PropTypes.func,
        onGroupPanelExpandedChange  : PropTypes.func,
        onAddGroup                  : PropTypes.func,
        onDeleteGroup               : PropTypes.func,
        onMoveGroup                 : PropTypes.func,
        onIndicatorDataChange       : PropTypes.func,
        onIndicatorGroupChange      : PropTypes.func,
        onIndicatorObjListChange    : PropTypes.func,
        onIndicatorParamLabChange   : PropTypes.func,
        onIndicatorTargPopCurrIDChange : PropTypes.func,
        onIndicatorTargPopTypeChange : PropTypes.func,

    };

    static defaultProps = {

        appBarHeight                : 0,
        appSideBarWidth             : 0,

        appState                    : {},
        onStateChange               : () => console.log("onStateChange"),

        onAddTasks                  : () => console.log("onAddTasks"),
        getDataVisChart             : () => console.log("getDataVisChart"),
        onDrawerChange              : () => console.log("onDrawerChange"),
        onPageChange                : () => console.log("onPageChange"),
        onProjChange                : () => console.log("onProjChange"),
        onPackTableChange           : () => console.log("Content onPackTableChange"),

        left                        : 0,

        onQ1Answered                : () => console.log("onQ1Answered"),
        onQ2Answered                : () => console.log("onQ2Answered"),

        onSideBarArrowClick         : () => console.log("onSideBarArrowClick"),

        onTargPopParamValueChange   : () => console.log("onTargPopParamValueChange"),
        onTargPopCustomStrChange    : () => console.log("onTargPopCustomStrChange"),
        onSelectedIndicatorChange   : () => console.log("onSelectedIndicatorChange"),
        onAnalyzeIndicatorChange    : () => console.log("onAnalyzeIndicatorChange"),
        onIndicatorNameChange       : () => console.log("onIndicatorNameChange"),
        onGroupNameChange           : () => console.log("onGroupNameChange"),
        onGroupPanelExpandedChange  : () => console.log("onGroupPanelExpandedChange"),
        onAddGroup                  : () => console.log("onAddGroup"),
        onDeleteGroup               : () => console.log("onDeleteGroup"),
        onMoveGroup                 : () => console.log("onMoveGroup"),
        onIndicatorDataChange       : () => console.log("onIndicatorDataChange"),
        onIndicatorGroupChange      : () => console.log("onIndicatorGroupChange"),
        onIndicatorObjListChange    : () => console.log("onIndicatorObjListChange"),
        onIndicatorParamLabChange   : () => console.log("onIndicatorParamLabChange"),
        onIndicatorTargPopCurrIDChange : () => console.log("onIndicatorTargPopCurrIDChange"),
        onIndicatorTargPopTypeChange : () => console.log("onIndicatorTargPopTypeChange"),
    };

    //==================================================================================================================
    //
    //                                                Render
    //
    //==================================================================================================================


    renderPage = () => {

        /* Props */
        const props = this.props;
        const onDrawerChange = props.onDrawerChange;
        const onPageChange = props.onPageChange;
        const onQ1Answered = props.onQ1Answered;
        const onQ2Answered = props.onQ2Answered;
        const onSideBarArrowClick = props.onSideBarArrowClick;
        const onAnalyzeIndicatorChange = props.onAnalyzeIndicatorChange;
        const onIndicatorNameChange = props.onIndicatorNameChange;
        const onSelectedIndicatorChange = props.onSelectedIndicatorChange;
        const onTargPopParamValueChange = props.onTargPopParamValueChange;
        const onGroupPanelExpandedChange = props.onGroupPanelExpandedChange;
        const onIndicatorDataChange = props.onIndicatorDataChange;
        const onIndicatorObjListChange = props.onIndicatorObjListChange;
        const onIndicatorParamLabChange = props.onIndicatorParamLabChange;
        const onIndicatorTargPopCurrIDChange = props.onIndicatorTargPopCurrIDChange;
        const onIndicatorTargPopTypeChange = props.onIndicatorTargPopTypeChange;
        const onTargPopCustomStrChange = props.onTargPopCustomStrChange;
        const appSideBarWidth = props.appSideBarWidth;
        const appBarHeight = props.appBarHeight;

        /* appState */
        const appState = props.appState;
        const pageID = appState.pageID;
        const drawerID = appState.drawerID;
        const drawerOpen = appState.drawerOpen;
        const answer1Byte = appState.answer1Byte;
        const answer2Byte = appState.answer2Byte;
        const indicatorObjList = appState.indicatorObjList;
        const selectedIndCurrID = appState.selectedIndCurrID;
        const targPopObjList = appState.targPopObjList;
        const groupObjList = appState.groupObjList;

        const styles = {
            appPage : {
                left : this.props.left,
            },
        };

        let page;

        switch (pageID) {

            case rcc.welcomeForm :
                page =
                    <RCWelcomeForm
                        onDrawerChange                 = {onDrawerChange}

                        pageID                         = {pageID}
                        onPageChange                   = {onPageChange}
                        onQ1Answered                   = {onQ1Answered}
                        onSideBarArrowClick            = {onSideBarArrowClick}
                    />;
                break;

            case rcc.selectIndicatorsForm :
                page =
                    <RCSelectIndicatorsForm
                        appBarHeight               = {appBarHeight}
                        appSideBarWidth            = {appSideBarWidth}

                        onDrawerChange             = {onDrawerChange}
                        onPageChange               = {onPageChange}

                        groupObjList               = {groupObjList}
                        onGroupPanelExpandedChange = {onGroupPanelExpandedChange}

                        indicatorObjList           = {indicatorObjList}
                        onAnalyzeIndicatorChange   = {onAnalyzeIndicatorChange}
                        onIndicatorNameChange      = {onIndicatorNameChange}
                        onIndicatorObjListChange   = {onIndicatorObjListChange}

                        selectedIndCurrID           = {selectedIndCurrID}
                        onSelectedIndicatorChange   = {onSelectedIndicatorChange}
                    />;
                break;

            case rcc.assignTargPopsForm :
                page =
                    <RCAssignTargPopsForm
                        onPageChange                = {onPageChange}

                        targPopObjList              = {targPopObjList}

                        indicatorObjList            = {indicatorObjList}
                        onIndicatorParamLabChange   = {onIndicatorParamLabChange}
                        onIndicatorTargPopCurrIDChange = {onIndicatorTargPopCurrIDChange}
                        onIndicatorTargPopTypeChange = {onIndicatorTargPopTypeChange}
                        onIndicatorObjListChange   = {onIndicatorObjListChange}

                        selectedIndCurrID           = {selectedIndCurrID}
                        onSelectedIndicatorChange   = {onSelectedIndicatorChange}

                        onTargPopParamValueChange   = {onTargPopParamValueChange}
                        onTargPopCustomStrChange    = {onTargPopCustomStrChange}
                    />;
                break;

            case rcc.parametersForm :
                page =
                    <RCParametersForm
                        targPopObjList        = {targPopObjList}
                        groupObjList          = {groupObjList}
                        indicatorObjList      = {indicatorObjList}
                        answer1Byte           = {answer1Byte}
                        answer2Byte           = {answer2Byte}
                        onQ2Answered          = {onQ2Answered}
                        onPageChange          = {onPageChange}
                        onIndicatorDataChange = {onIndicatorDataChange}
                    />;
                break;

            case rcc.resultsForm :
                page =
                    <RCResultsForm
                        targPopObjList        = {targPopObjList}
                        groupObjList          = {groupObjList}
                        indicatorObjList      = {indicatorObjList}
                        answer1Byte           = {answer1Byte}
                        answer2Byte           = {answer2Byte}
                        onQ2Answered          = {onQ2Answered}
                        onPageChange          = {onPageChange}
                        onIndicatorDataChange = {onIndicatorDataChange}
                    />;
                break;

            default :
                page =
                    <TAppPage style = {styles.appPage}>

                        I DON'T EXIST YET!  MY PAGE ID IS "{this.props.pageID}"

                    </TAppPage>;
                break;
        }

        let slideDrawer = null;

        if (drawerOpen) {

            switch (drawerID) {

                case rcc.customIndDrawer :
                    slideDrawer =
                        <RCCustomIndicatorDrawer
                            onDrawerChange           = {onDrawerChange}

                            indicatorObjList         = {indicatorObjList}
                            onIndicatorObjListChange = {onIndicatorObjListChange}

                            selectedIndCurrID         = {selectedIndCurrID}
                            onSelectedIndicatorChange = {onSelectedIndicatorChange}
                        />;
                    break;

                default : 
                    return null;

            }
        }

        return (

            <div>

                <ErrorBoundaryPage key = {pageID} >

                    <TAppPage style = {styles.appPage}>

                        {page}
                        {slideDrawer}

                    </TAppPage>

                </ErrorBoundaryPage>

            </div>

        );

    };

    render() {
        const page = this.renderPage();
        return page;
    }
}

export default RCAppContent;